// ColorConfig/colorconfig.js
export let colors = {
  primary: '#E57627',        
  primaryRgb: '229, 118, 39',
  bodyBlack: '#1A1A1A',     
  hoverBlack: '#1B1B1B',     
  cardBgBlack: '#242424',    
  deepBlack: '#111111',
  black: '#000000',
  gray: '#848484ff',
  white: '#FFFFFF',          
  primaryHover: '#D16A23',  
  primaryLight: '#ffe7d7ff',  
  blackTransparent: 'rgba(26, 26, 26, 0.95)',
  whiteTransparent: 'rgba(255, 255, 255, 0.95)',
  primaryTransparent: 'rgba(229, 118, 39, 0.1)',
};

// Function to update colors dynamically
export const updateColors = (newColors) => {
  colors = { ...colors, ...newColors };
  injectCSSVariables();
  
  // Dispatch a custom event to notify components of color changes
  window.dispatchEvent(new CustomEvent('themeChanged', { detail: newColors }));
};

export const injectCSSVariables = () => {
  const root = document.documentElement;
  Object.entries(colors).forEach(([key, value]) => {
    root.style.setProperty(`--color-${key}`, value);
  });
};

// Initialize CSS variables on import
injectCSSVariables();

export const {
  primary,
  primaryRgb,
  bodyBlack,
  hoverBlack,
  cardBgBlack,
  deepBlack,
  white,
  primaryHover,
  primaryLight,
  blackTransparent,
  whiteTransparent,
  primaryTransparent
} = colors;

export default colors;